import React from "react";
import { motion } from "framer-motion";
import { BsEnvelope, BsInstagram, BsLinkedin } from "react-icons/bs";

function SocialMedia({ isContact }) {
    return (
        <div
            className={`${
                isContact === true
                    ? " "
                    : "hidden md:flex fixed z-50 bottom-5 left-4"
            }`}>
            <motion.div
                className={`${
                    isContact === true
                        ? "flex justify-center items-center"
                        : "text-2xl"
                }`}
                whileInView={
                    !isContact
                        ? { x: [-50, 0], opacity: [0, 1] }
                        : { y: [50, 0], opacity: [0, 1] }
                }
                transition={
                    !isContact
                        ? { duration: 1, delay: 1, ease: "easeInOut" }
                        : { ease: "easeInOut" }
                }>
                <a
                    href="https://www.instagram.com/s.h.u.b.u._/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <div className="floating-buttons">
                        <BsInstagram />
                    </div>
                </a>
                <a
                    href="https://in.linkedin.com/in/shubhankar-nautiyal"
                    target="_blank"
                    rel="noopener noreferrer">
                    <div className="floating-buttons">
                        <BsLinkedin />
                    </div>
                </a>
                <a
                    href="mailto:shubhankar.nautiyal21@gmail.com?subject=Hello%20Shubhankar%20"
                    target="_blank"
                    rel="noopener noreferrer">
                    <div className="floating-buttons">
                        <BsEnvelope />
                    </div>
                </a>
            </motion.div>
        </div>
    );
}

export default SocialMedia;
